import { Link, useLocation } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { CheckCircle2, ArrowRight, Twitter, Linkedin, Mail, Share2 } from "lucide-react";

export default function ThankYouPage() {
  const location = useLocation();
  
  const shareUrl = "https://foundrscore.com";
  const shareText = "Just took the Business Idea Stress Test on FoundrScore - great tool for founders! 🚀";

  const handleShare = (platform) => {
    let url = "";
    switch (platform) {
      case "twitter":
        url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`;
        break;
      case "linkedin":
        url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
        break;
      case "email":
        url = `mailto:?subject=${encodeURIComponent("Check out FoundrScore")}&body=${encodeURIComponent(shareText + "\n\n" + shareUrl)}`;
        break;
      default:
        return;
    }
    window.open(url, "_blank");
  };

  return (
    <div className="py-12 min-h-[80vh] flex items-center">
      <div className="max-w-lg mx-auto px-4 sm:px-6 w-full text-center">
        <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6">
          <CheckCircle2 className="w-10 h-10 text-primary" />
        </div>
        
        <h1 className="text-3xl sm:text-4xl font-bold mb-4">You're In!</h1>
        <p className="text-muted-foreground mb-8">
          Thanks for joining FoundrScore. We'll keep you updated with the latest validation tools and founder insights.
        </p>

        <Card className="mb-8" data-testid="thank-you-card">
          <CardContent className="p-6">
            <h3 className="font-semibold mb-4">What's Next?</h3>
            <ul className="space-y-3 text-left">
              <li className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 text-primary flex items-center justify-center text-sm font-semibold">1</span>
                <span className="text-sm">Check your inbox for a welcome email</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 text-primary flex items-center justify-center text-sm font-semibold">2</span>
                <span className="text-sm">Take the Business Idea Stress Test</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 text-primary flex items-center justify-center text-sm font-semibold">3</span>
                <span className="text-sm">Complete your Validation Canvas</span>
              </li>
            </ul>
          </CardContent>
        </Card>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <Link to="/quiz">
            <Button className="rounded-full px-8" data-testid="thankyou-quiz-btn">
              Take the Stress Test
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
          <Link to="/canvas">
            <Button variant="outline" className="rounded-full px-8" data-testid="thankyou-canvas-btn">
              Create Your Canvas
            </Button>
          </Link>
        </div>

        {/* Social Sharing */}
        <div className="pt-8 border-t border-border/40">
          <p className="text-sm text-muted-foreground mb-4 flex items-center justify-center gap-2">
            <Share2 className="w-4 h-4" />
            Share with fellow founders
          </p>
          <div className="flex justify-center gap-3">
            <Button
              variant="outline"
              size="icon"
              className="rounded-full"
              onClick={() => handleShare("twitter")}
              data-testid="share-twitter-btn"
            >
              <Twitter className="w-4 h-4" />
            </Button>
            <Button
              variant="outline"
              size="icon"
              className="rounded-full"
              onClick={() => handleShare("linkedin")}
              data-testid="share-linkedin-btn"
            >
              <Linkedin className="w-4 h-4" />
            </Button>
            <Button
              variant="outline"
              size="icon"
              className="rounded-full"
              onClick={() => handleShare("email")}
              data-testid="share-email-btn"
            >
              <Mail className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
